<template>
  <v-card
    :style="`background: linear-gradient(to bottom right, ${color[0]}, ${color[1]})`"
    class="rounded-xl d-flex flex-column pb-8 fill-height"
    dark
    elevation="5"
    min-height="400"
  >
    <div>
      <v-responsive :aspect-ratio="5 / 3">
        <div class="d-flex justify-center align-center fill-height flex-column">
          <div
            :id="`panel.text.wrapper${item.id}`"
            class="ribbon-text-wrapper text-center mb-3"
            style="color: #fec601"
          >
            <span
              :id="`panel.text${item.id}`"
              style="text-shadow: 1px 2px 4px rgba(0, 0, 0, 0.4)"
            >
              {{ item.title }}
            </span>
          </div>
          <div class="text-center font-size-h5">
            {{ use_lang(price(item.price)) }}
            <span class="ms-1" style="font-size: 0.8em">{{
              $t("panelCard.rial")
            }}</span>
            <br />
            {{ use_lang(item.expire) }} {{ $t("panelCard.days") }}
          </div>
        </div>
      </v-responsive>
    </div>

    <v-card-text class="text-center pb-0">
      <div v-for="(feature, j) in item.features" :key="j" class="mb-1">
        {{ feature.key }} :
        <span class="font-weight-bold white--text">{{ feature.value }}</span>
      </div>
    </v-card-text>

    <v-spacer />

    <v-divider />
    <v-card-title
      class="break-word text-center justify-center pt-0"
      style="font-size: 1.05em"
    >
      {{ item.description }}
    </v-card-title>

    <v-card-actions class="planning-action justify-center">
      <v-btn
        color="#FF7F11"
        elevation="5"
        large
        min-width="120"
        rounded
        @click="$emit('buy', item)"
      >
        {{ $t("panelCard.buyPanel") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "panelCard",

  props: {
    item: Object,
    color: [Array, String],
  },

  data: () => ({
    status: 0,
  }),

  mounted() {
    this.checkTextOverflow();
  },

  methods: {
    checkTextOverflow() {
      if (this.status > 1) return;

      this.$nextTick(() => {
        let wrapper = document.getElementById(
          `panel.text.wrapper${this.item.id}`
        );
        let text = document.getElementById(`panel.text${this.item.id}`);

        if (wrapper) {
          let wrapperCliW = wrapper.getClientRects()[0].width;
          let textCliW = text.getClientRects()[0].width;

          if (wrapperCliW >= textCliW) {
            setTimeout(() => {
              this.status += 1;
              this.checkTextOverflow();
            }, 5000);
          } else if (wrapperCliW < textCliW) {
            text.classList.add("set-transition");
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.break-word {
  word-break: break-word;
}

.planning-action {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateY(50%);
}

.v-btn {
  text-indent: unset !important;
  letter-spacing: unset !important;
}

.ribbon-text-wrapper {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  font-size: 2em;
  max-width: calc(100% - 16px);
}

.ribbon-text-wrapper >>> span {
  display: inline-block;
  transition: all 0.1s linear;
}

.set-transition {
  transform: translateX(-100%);
  animation-delay: 1000s;
  animation: scrolling-text 5s infinite linear;
}

@keyframes scrolling-text {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100%);
  }
}
</style>
